'use client';

import React from 'react';
import { LayoutGrid, List } from 'lucide-react';

interface ApartmentListingHeaderProps {
  count: number;
  total: number;
  viewMode: 'grid' | 'list';
  onViewModeChange: (v: 'grid' | 'list') => void;
  sortBy: string;
  onSortChange: (v: string) => void;
}

const sortOptions = [
  { value: 'featured', label: 'Featured First' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'rating', label: 'Top Rated' },
];

export default function ApartmentListingHeader({
  count, total, viewMode, onViewModeChange, sortBy, onSortChange,
}: ApartmentListingHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <div>
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-bold text-foreground">{count}</span> of{' '}
          <span className="font-bold text-foreground">{total}</span> apartments
        </p>
      </div>
      <div className="flex items-center gap-3">
        <select
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
          className="input-field py-2 text-sm w-auto"
        >
          {sortOptions.map((opt) => (
            <option key={`sort-${opt.value}`} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        <div className="flex items-center border border-border rounded-xl overflow-hidden">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`p-2.5 transition-colors ${viewMode === 'grid' ? 'bg-primary text-white' : 'hover:bg-muted text-muted-foreground'}`}
            aria-label="Grid view"
          >
            <LayoutGrid size={16} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`p-2.5 transition-colors ${viewMode === 'list' ? 'bg-primary text-white' : 'hover:bg-muted text-muted-foreground'}`}
            aria-label="List view"
          >
            <List size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}